<template>
    <f-dialog
        v-if          = "incident"
        v-model       = "value"
        :width        = "950"
        :hide-actions = "false"
        :show-header  = "false"
        :show-save    = "false"
        @cancel       = "onCancel"
    >
        <template v-slot:content>
            <div class="inc-history mt-3 mb-3">
                <div
                    v-for="(step,index) in history"
                    :key="index"
                    :class="index===0?'':'mt-4'"
                >
                    <div class="inc-history-step primary white--text" v-if="step.entries.length > 0">
                        {{ step.name }}
                    </div>

                    <div
                        v-for="entry in step.entries"
                        :key = "entry.id"
                    >
                        <div>
                            <div class="history-unit">
                                {{ entry.unit.fabricNo }} - {{ $t('top.site.location', [ entry.unit.street, entry.unit.zip, entry.unit.city ]) }}
                            </div>
                            <c-inc-status-history
                                v-if     = "entry.history.length > 0"
                                :history = "entry.history"
                                style    = "margin-left: 10px"
                            />
                        </div>
                    </div>


                    <div v-for="(bid, idx) in step.bids" :key="idx" class="mt-2">
                        <div class="inc-history-bid  primary--text" :class="idx===0?'':'mt-4'">
                            {{ $t("repair.bid.name." + bid.name) }}
                            <i v-if="bid.favorite" class="fas fa-star ml-2"></i>
                        </div>
                        <c-inc-status-history :history="bid.history" style="margin-left: 10px"/>
                    </div>
                </div>
            </div>
        </template>
    </f-dialog>
</template>

<script>

import moment from "moment";
import FDialog from "@/modules/core/components/utils/FDialog.vue";
import CIncStatusHistory from "@/modules/inc/history/CIncStatusHistory.vue";

export default {
    name: "DIncHistory",

    components: {
        CIncStatusHistory,
        FDialog
    },
    props: {
        incident: {
            required: true,
            type    : Object,
            default : function () {
                return null;
            }
        },
        value: {
            required: true,
        }
    },

    data: () => ({
    }),

    mounted() {
        if (this.value) {
            this.load();
        }
    },

    watch: {
        value () {
            if (this.value) {
                this.load();
            }

            this.$emit("input", this.value);
        }
    },

    computed: {
        history() {
            return this.$store.getters.stepdatahistory;
        },
    },

    methods: {
        async load () {
            await this.$store.dispatch('findHistoryByIncident', this.incident.id);
        },

        onCancel () {
            this.$emit("input", false);
        },

        format (value) {
            if (value === null) return "";
            return moment (value).format('DD.MM.YYYY HH:mm');
        },
    }
}
</script>

<style scoped>

.inc-history {
    max-height: 800px;
    overflow-y: auto;
    padding-right: 5px;
}

.inc-history-step {
    font-size: 16px;
    height: 32px;
    padding-left: 10px;
    padding-top: 4px;
    border-radius: 5px;
}

.history-unit {
    font-size: 15px;
    background-color: aliceblue;
    height: 30px;
    margin-top: 2px;
    padding-top: 3px;
    padding-left: 6px;
    border-radius: 4px;
}

.inc-history-bid {
    font-size: 16px;
    margin-left: 10px;
    font-weight: 500;
}

</style>